import React from 'react'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import SectionActions from '../../Redux/SectionRedux'
import CreateSection from '../../Containers/Section/CreateSection'
import CreateSubSection from '../../Containers/Section/CreateSubSection'
import UpdateSection from '../../Containers/Section/UpdateSection'
import UpdateSectionImage from '../../Containers/Section/UpdateSectionImage'
import UpdateSubSection from '../../Containers/Section/UpdateSubSection'
import UpdateSubSectionImage from '../../Containers/Section/UpdateSubsectionImage'
import UpdateSubSectionPDF from '../../Containers/Section/UpdateSubsectionPDF'
import DeleteSection from '../../Containers/Section/DeleteSection'
import DeleteSubSection from '../../Containers/Section/DeleteSubSection'
import DescriptionButton from '../../Components/EllipsisModal'

class SectionPage extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: null,
      detail: {}
    }
  }

  componentDidMount = () => {
    this._fetchSection()
  }

  _fetchSection = () => {
    this.props.getSection()
  }

  _selectItem = (item, modalID) => {
    this.setState({ detail: item })
    this._toggleModal(modalID)
  }

  _toggleModal = (modalID = null) => {
    this.setState({ showModal: modalID })
    if (!modalID) { this._fetchSection() }
  }

  _renderSection = (data) => (
    <section>
      <div className='text-left mb-2'>
        <button data-toggle='collapse' data-target={`#collapse-${data.id}`} className='btn btn-info text-center' type='button'>
          <i className='fa fa-eye' /> View Subsection
        </button>
      </div>
      <table className='table-bordered' style={{ maxWidth: '100vw' }}>
        <thead style={{ overflowX: 'auto' }}>
          <tr>
            <th style={{ minWidth: '200px' }} className='text-center align-middle'>Title ID</th>
            <th style={{ minWidth: '200px' }} className='text-center align-middle'>Title EN</th>
            <th style={{ minWidth: '200px' }} className='text-center align-middle'>Status</th>
            <th style={{ minWidth: '200px' }} className='text-center align-middle'>Banner</th>
            <th style={{ minWidth: '200px' }} className='text-center align-middle' colSpan='2'>Edit Section</th>
            <th style={{ minWidth: '200px' }} className='text-center align-middle'>Delete section</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className='text-center align-middle'>{data.title_id || '-'}</td>
            <td className='text-center align-middle'>{data.title_en || '-'}</td>
            <td className='text-center align-middle'>
              <strong>{data.status === 'active' ? 'Active' : 'Inactive'}</strong>
            </td>
            <td className='text-center align-middle'>
              <button disabled={!data.image_file} className='btn btn-info' onClick={() => this._selectItem(data, 'modal-VIEW-BANNER')}>
                <i className='fa fa-eye' />
              </button>
            </td>
            <td className='text-center align-middle'>
              <button className='btn btn-primary' onClick={() => this._selectItem(data, 'modal-PUT')}>
                Contents <i className='fa fa-edit' />
              </button>
            </td>
            <td className='text-center align-middle'>
              <button className='btn btn-primary' onClick={() => this._selectItem(data, 'modal-PUT-IMAGE')}>
                Banner <i className='fa fa-edit' />
              </button>
            </td>
            <td className='text-center align-middle'>
              <button className='btn btn-danger' onClick={() => this._selectItem(data, 'modal-DELETE')}>
                <i className='fa fa-trash' />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div className='collapse' id={`collapse-${data.id}`}>
        <div className='text-left mt-3 mb-2'>
          <button className='btn btn-primary' onClick={() => this._selectItem(data, 'modal-POST-SUB')}><i className='fa fa-plus' /> Add Subsection</button>
        </div>
        {this._renderSubSection(data.section_data)}
      </div>
    </section>
  )

  _renderSubSection = (data) => (
    <table className='table-bordered'>
      <thead>
        <tr>
          <th className='text-center align-middle'>Title ID</th>
          <th className='text-center align-middle'>Title EN</th>
          <th className='text-center align-middle'>Subtitle</th>
          <th className='text-center align-middle'>Description</th>
          <th className='text-center align-middle'>Image file</th>
          <th className='text-center align-middle'>PDF file</th>
          <th className='text-center align-middle' colSpan='3'>Edit Subsection</th>
          <th className='text-center align-middle'>Delete Subsection</th>
        </tr>
      </thead>
      <tbody>
        {
          !data || data.length === 0
            ? <tr>
              <td className='text-center align-middle' colSpan='9'>--No Data--</td>
            </tr>
            : data.map((item, i) => (
              <tr key={i}>
                <td className='text-center align-middle'>{ item.title_id || '-' }</td>
                <td className='text-center align-middle'>{ item.title_en || '-' }</td>
                <td className='text-center align-middle'>{ item.subtitle || '-' }</td>
                <td className='text-center align-middle'>
                  <DescriptionButton descriptor='Description' name={item.title} description={item.description} type='string' />
                </td>
                <td className='text-center align-middle'>
                  <button disabled={!item.image_file} className='btn btn-info' onClick={() => this._selectItem(item, 'modal-VIEW-IMAGE')}><i className='fa fa-eye' /></button>
                </td>
                <td className='text-center align-middle'>
                  {
                    !item.pdf_file
                      ? '--'
                      : <a href={item.pdf_url} target='_blank'>{item.pdf_file}</a>
                  }
                </td>
                <td className='text-center align-middle'>
                  <button className='btn btn-primary' onClick={() => this._selectItem(item, 'modal-PUT-SUB')}>
                    Contents <i className='fa fa-edit' />
                  </button>
                </td>
                <td className='text-center align-middle'>
                  <button className='btn btn-primary' onClick={() => this._selectItem(item, 'modal-PUT-SUB-IMAGE')}>
                    Image <i className='fa fa-edit' />
                  </button>
                </td>
                <td className='text-center align-middle'>
                  <button className='btn btn-primary' onClick={() => this._selectItem(item, 'modal-PUT-SUB-PDF')}>
                    PDF <i className='fa fa-edit' />
                  </button>
                </td>
                <td className='text-center align-middle'>
                  <button className='btn btn-danger' onClick={() => this._selectItem(item, 'modal-DELETE-SUB')}>
                    <i className='fa fa-trash' />
                  </button>
                </td>
              </tr>
            ))
        }
      </tbody>
    </table>
  )

  render () {
    const { section } = this.props
    return (
      <section>
        <header className='section'>
          <div className='title-block d-flex mb-3 justify-content-between'>
            <h3 className='title mr-auto'>
              Manage Sections
              {
                (section.fetching || section.processing) &&
                <div className='badge badge-info ml-2'>Loading ...</div>
              }
            </h3>
            <button className='btn btn-primary' onClick={() => this._toggleModal('modal-POST')}>Create Section <i className='fa fa-plus' /></button>
          </div>
        </header>
        <div className='card'>
          <table className='table table-striped table-hover'>
            <thead>
              <tr>
                <th className='text-center align-middle'>Section Data</th>
              </tr>
            </thead>
            <tbody>
              {
                !section.data || section.data.length === 0
                  ? <tr>
                    <td className='text-center align-middle' colSpan='2'>--No Data--</td>
                  </tr>
                  : section.data.map((item, i) => (
                    <tr key={i}>
                      <td className='text-center align-middle'>{this._renderSection(item)}</td>
                    </tr>
                  ))
              }
            </tbody>
          </table>
        </div>

        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.showModal === 'modal-VIEW-BANNER'} onClose={this._toggleModal}>
          <section className='section' style={{ width: '100%' }}>
            <div className='title-block'>
              <h4 className='title'>View Banner Image</h4>
            </div>
            <div className='text-center align-middle align-middle'>
              <img style={{ maxWidth: '65vw', maxHeight: '65vh' }} src={this.state.detail.image_url} alt={this.state.detail.image_file} className='img img-responsive' />
            </div>
            <div className='text-center align-middle'>
              <h6 className='mt-3'>Banner for: <a href={this.state.detail.image_url} target='_blank'>{this.state.detail.title_id}</a></h6>
            </div>
            <div className='text-right'>
              <button className='btn btn-primary mt-3' onClick={() => this._toggleModal()}>Close</button>
            </div>
          </section>
        </Modal>

        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.showModal === 'modal-VIEW-IMAGE'} onClose={this._toggleModal}>
          <section className='section' style={{ width: '100%' }}>
            <div className='title-block'>
              <h4 className='title'>View Boxed Image</h4>
            </div>
            <div className='text-center align-middle align-middle'>
              <img style={{ maxWidth: '65vw', maxHeight: '65vh' }} src={this.state.detail.image_url} alt={this.state.detail.image_file} className='img img-responsive text-center align-middle' />
            </div>
            <div className='text-center align-middle'>
              <h6 className='mt-3'>Banner for: <a href={this.state.detail.image_url} target='_blank'>{this.state.detail.title_id}</a></h6>
            </div>
            <div className='text-right'>
              <button className='btn btn-primary mt-3' onClick={() => this._toggleModal()}>Close</button>
            </div>
          </section>
        </Modal>

        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.showModal === 'modal-POST'} onClose={this._toggleModal}>
          <CreateSection closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.showModal === 'modal-POST-SUB'} onClose={this._toggleModal}>
          <CreateSubSection detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.showModal === 'modal-PUT'} onClose={this._toggleModal}>
          <UpdateSection detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.showModal === 'modal-PUT-IMAGE'} onClose={this._toggleModal}>
          <UpdateSectionImage detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.showModal === 'modal-PUT-SUB'} onClose={this._toggleModal}>
          <UpdateSubSection detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.showModal === 'modal-PUT-SUB-IMAGE'} onClose={this._toggleModal}>
          <UpdateSubSectionImage detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.showModal === 'modal-PUT-SUB-PDF'} onClose={this._toggleModal}>
          <UpdateSubSectionPDF detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.showModal === 'modal-DELETE'} onClose={this._toggleModal}>
          <DeleteSection detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.showModal === 'modal-DELETE-SUB'} onClose={this._toggleModal}>
          <DeleteSubSection detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  section: state.section
})

const dispatchToProps = (dispatch) => ({
  getSection: () => dispatch(SectionActions.getSectionRequest())
})

export default connect(stateToProps, dispatchToProps)(SectionPage)



// WEBPACK FOOTER //
// ./src/Pages/Misc/SectionPage.js